export default __webpack_public_path__ + "static/media/gifGenerator.5f91d73e.png";